import React from 'react';
import InfoIcon from '@mui/icons-material/InfoRounded';
import {
  ClaimAcknowledgementStatusDTO,
} from 'dtos';
import {
  formatDate,
  formatDateTime,
} from 'utils/date';
import {
  notEmptyString,
} from '@populateui/utils';
import ClaimAcknowledgementContent from 'pages/Dashboard/pages/Billing/Charges/ClaimAcknowledgementContent';

type DateHeaderProps = {
  date: string;
  label: string;
  showTime?: boolean;
};

function DateHeader({
  date,
  label,
  showTime = false,
}: DateHeaderProps) {
  return (
    <div className="flex flex-col font-semibold gap-1 pr-2 border-r border-r-gray-200 last:!border-r-0 last:!pr-0">
      <span className="text-gray-400">{label}</span>
      {showTime ? formatDateTime(date) : formatDate(date)}
    </div>
  );
}

export default function ClaimAcknowledgementPopover({
  statusDate,
  updatedOn,
  statusMessage,
  ...props
}: ClaimAcknowledgementStatusDTO) {
  return (
    <div className="flex flex-col w-full gap-2">
      <div className="flex gap-2 items-center">
        <InfoIcon className="!w-6 !h-6 !text-purple-600" />
        <DateHeader
          label="Effective from"
          date={statusDate ?? ''}
        />
        <DateHeader
          label="Updated on"
          date={updatedOn ?? ''}
          showTime
        />
      </div>
      {notEmptyString(statusMessage) && <p>{statusMessage}</p>}
      <div className="flex flex-col w-full gap-2">
        <ClaimAcknowledgementContent {...props} />
      </div>
    </div>
  );
}
